module.exports = __webpack_public_path__ + "static/media/RJC_2023.0fb5f07a.jpg";